export const api_HOST =
  process.env.NODE_ENV === "production" ?
  "https://api.mbr.liquan.com/api" :
  "https://api.mbr.massestech.com/api";